import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CodeItem = ({ code, description }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      <Text type="bodyMRegular">{code}</Text>
      <Styles.Description>
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          - {description}
        </Text>
      </Styles.Description>
    </Styles.Container>
  )
}

export default CodeItem
